import { render } from "./tagsView.vue?vue&type=template&id=b5652f08&scoped=true&ts=true"
import script from "./tagsView.vue?vue&type=script&lang=ts"
export * from "./tagsView.vue?vue&type=script&lang=ts"

import "./tagsView.vue?vue&type=style&index=0&id=b5652f08&lang=scss&scoped=true"

import exportComponent from "E:\\bjft\\bjft-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5652f08"]])

export default __exports__